<div class="container main-div">
  <mat-card class="page-not-found">
    <mat-card-header style="flex-direction: column;">
      <mat-card-title >PÃ¡gina nÃ£o encontrada!</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div>
        <img src="assets/img/page-not-found.png" alt="PÃ¡gina nÃ£o encontrada" />
      </div>
    </mat-card-content>
    <mat-card-actions class="card-button">
      <button mat-raised-button color="primary" (click)="voltar()">
        <mat-icon>undo</mat-icon> Voltar
      </button>
    </mat-card-actions>
  </mat-card>
</div>
